import React from 'react';
import { Chip } from '@mui/material';
import PropTypes from 'prop-types';

const COLOR_BY_STATUS = {
  eligible: 'mrrEligible',
  ineligible: 'mrrIneligible',
  under_review: 'mrrReview',
  further_review: 'mrrReview',
};

const LABEL_BY_STATUS = {
  eligible: 'Eligible',
  ineligible: 'Ineligible',
  under_review: 'Under review',
  further_review: 'Further review',
};

const LABEL_BY_SUBSTATUS = {
  awaiting_records: 'Awaiting records',
  evaluating: 'Evaluating',
  needs_eval: 'Needs evaluation',
};

export function MrrTag({ status, substatus, error }) {
  if (!status) return null;
  const key = String(status).toLowerCase().replace(/\s+/g, '_');
  const subKey = substatus ? String(substatus).toLowerCase().replace(/\s+/g, '_') : '';
  const baseLabel = LABEL_BY_STATUS[key] || status;
  const label = key === 'under_review' && LABEL_BY_SUBSTATUS[subKey]
    ? `${baseLabel} · ${LABEL_BY_SUBSTATUS[subKey]}`
    : baseLabel;
  return (
    <span className="onyx-mrr-tag-wrap" data-testid="onyx-mrr-tag-wrap">
      <Chip
        size="small"
        color={COLOR_BY_STATUS[key] || 'default'}
        label={label}
        data-testid="onyx-mrr-tag"
        data-substatus={subKey || undefined}
      />
      {error ? (
        <span
          className="onyx-mrr-error"
          title={error}
          aria-label={`Automation error: ${error}`}
          data-testid="onyx-mrr-error"
        >
          !
        </span>
      ) : null}
    </span>
  );
}

MrrTag.propTypes = {
  status: PropTypes.string,
  substatus: PropTypes.string,
  error: PropTypes.string,
};
